export const modifierList = [
  '',
  'dark',
  'bold',
  'bold-dark',
  'colored',
  'border',
  'border-light',
  'border-dark',
  'secondary',
  'no-margin-top',
];

export const tagList = ['h1', 'h2', 'h3'];
